module.exports = __webpack_public_path__ + "media/images/flags/bt-e108533ae7e11018e0dc70ea54c69107.svg";